import { create } from "zustand";
import { getBankTransferReference } from "../services/digitalWalletService";

interface BankReference {
  tail: string;
  status: string;
  user: string;
}

interface BankReferenceState {
  bankReference: BankReference | null;
  loading: boolean;
  error: string | null;
  fetchBankReference: () => Promise<void>;
  resetBankReference: () => void;
  generateReference: (type: string) => string | null;
}

export const useBankReferenceStore = create<BankReferenceState>((set, get) => ({
  bankReference: null,
  loading: false,
  error: null,

  fetchBankReference: async () => {
    const { loading, bankReference } = get();

    if (loading || bankReference) {
      return;
    }

    set({ loading: true, error: null });

    try {
      const response = await getBankTransferReference();

      if (response.data?.data) {
        set({
          bankReference: response.data.data,
          loading: false,
          error: null,
        });
      } else {
        throw new Error("Failed to fetch bank transfer reference");
      }
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to fetch bank reference";
      set({
        error: errorMessage,
        loading: false,
        bankReference: null,
      });
      console.error("Error fetching bank reference:", err);
    }
  },

  resetBankReference: () =>
    set({
      bankReference: null,
      loading: false,
      error: null,
    }),

  generateReference: (type: string) => {
    const { bankReference } = get();

    if (!bankReference?.tail) {
      return null;
    }

    return `${type.toUpperCase()}88${bankReference.tail}`;
  },
}));
